import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
// import { fetchCount } from './counterAPI';
const initialState = {
    customAlert: false,
    login: Cookies.get("username") == null ? true : false,
    HomePage:
        Cookies.get("username") != null&&(Cookies.get('type')=="1"||Cookies.get('type')=="3")
            ? true
            : false,
    UserInfo:false,
    adminPage: Cookies.get("username") != null&&Cookies.get('type')=="99"
        ? true
        : false,
    caiwuPage:
        Cookies.get("username") != null&&(Cookies.get('type')=="98")
            ? true
            : false,
    schoolAdminPage:
        Cookies.get("username") != null&&(Cookies.get('type')=="2")
            ? true
            : false,
};

export const modalsSlice = createSlice({
    name: 'modals',
    initialState,
    reducers: {
        openLogin: (state) => {
            state.login = true;
        },
        closeLogin: (state) => {
            state.login = false;
        },
        openHomePage: (state) => {
            state.HomePage = true;
        },
        closeHomePage: (state) => {
            state.HomePage = false;
        },
        openUserInfo: (state) => {
            state.UserInfo = true;
        },
        closeUserInfo: (state) => {
            state.UserInfo = false;
        },
        openAdminPage: (state) => {
            state.adminPage = true;
        },
        closeAdminPage: (state) => {
            state.adminPage = false;
        },
        openCaiwuPage: (state) => {
            state.caiwuPage = true;
        },
        closeCaiwuPage: (state) => {
            state.caiwuPage = false;
        },
        openSchoolAdminPage: (state) => {
            state.schoolAdminPage = true;
        },
        closeSchoolAdminPage: (state) => {
            state.schoolAdminPage = false;
        },
    },
});

export const selectLogin = (state) => state.modals.login;
export const selectHomePage = (state) => state.modals.HomePage;
export const selectUserInfo = (state) => state.modals.UserInfo;
export const selectAdminPage = (state) => state.modals.adminPage;
export const selectCaiwuPage = (state) => state.modals.caiwuPage;
export const selectSchoolAdminPage = (state) => state.modals.schoolAdminPage;


export const {
    openLogin,
    closeLogin,
    openHomePage,
    closeHomePage ,
    openUserInfo,
    closeUserInfo,
    openAdminPage,
    closeAdminPage,
    openCaiwuPage,
    closeCaiwuPage,
    openSchoolAdminPage,
    closeSchoolAdminPage,
} = modalsSlice.actions;

export default modalsSlice.reducer;
